module.exports = __webpack_public_path__ + "img/ioc1.e7811086.png";